import deepExtend from 'deep-extend';

export default (options) => (target) => {
    deepExtend(target.prototype, options);
};